"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSubHeaderSection = void 0;
exports.defaultSubHeaderSection = {
    title: 'Kowloon Districts',
    keyword: null,
    paragraph: 'Kowloon and Hong Kong Island are split by Victoria Harbour. Kowloon Peninsula is a hub of activity and no matter where you choose to live, Kowloon has a bit of something for everyone, with an added local flavour. If you want to enjoy an ocean view of Victoria Harbour, apartments in Hung Hom, Kowloon Station or Olympic Station are all good locations. If you are looking for some peace and quiet further away from the city, it is recommended to live in Kowloon Tong and Ho Man Tin. If you want something more hip and lively, flats in Mong Kok or Tsim Sha Tsui have a fresh energy right at their doorsteps.',
    translate: {
        keyword: 'Keyword:',
    },
};
